import { render, staticRenderFns } from "./TakeOrder2.vue?vue&type=template&id=204fd70c&scoped=true&"
import script from "./TakeOrder2.vue?vue&type=script&lang=js&"
export * from "./TakeOrder2.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrder2.vue?vue&type=style&index=0&id=204fd70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204fd70c",
  null
  
)

export default component.exports